import { ControllerAPI } from "../api/api";
import createListApiState from "./lib/ListApiState";

export const [
    executionErrorsSlice,
    loadExecutionErrors,
    updateExecutionErrorsManually
] = createListApiState({
    name: "ExecutionErrors",
    execute: ControllerAPI.loadExecutionErrors
});
